import CheckIcon from '@mui/icons-material/Check';
import { colors } from '../../../../../constants/theme';
import { Wrapper, Image, Title, ListItem, ListItemText, TextWrapper, ListWrapper } from './styles';

const WhyChoose = ({ title, image = { src: '', alt: '' }, list = [] }) => {
  return (
    <Wrapper>
      <Image src={image.src} alt={image.alt} loading="lazy" />
      <TextWrapper>
        <Title>{title}</Title>
        <ListWrapper>
          {list.map((item, index) => (
            <ListItem key={index}>
              <CheckIcon sx={{ fontSize: { xs: 22, md: 28 }, color: colors.primary }} />
              <ListItemText dangerouslySetInnerHTML={{ __html: item }} />
            </ListItem>
          ))}
        </ListWrapper>
      </TextWrapper>
    </Wrapper>
  );
};

export default WhyChoose;
